/**
 * The one shape of a member's local settings.
 *
 * Seven copies of this object used to live in seven files, and they had
 * drifted: one carried a `defaultPersona` nothing read after the persona
 * picker moved, one carried an `integrations` map from a feature that was
 * deleted, one had a typo for the Workbench tool key. Every reader now imports
 * this one, so a key added here exists everywhere at once.
 *
 * Pure: no DOM, no storage.
 */

export const SETTINGS_KEY = 'agilepro.settings.v1';

export const DEFAULT_TOOL = 'feature-to-stories';

export function createDefaultSettings() {
  return {
    teams: [],
    last: {
      projectId: '',
      teamId: '',
      team: '',
      persona: 'Agile Coach',
      lens: 'auto',
      event: 'daily',
      timebox: '15 min',
      notes: '',
      tool: DEFAULT_TOOL,
    },
    prefs: {
      defaultMode: 'discovery',
      theme: 'light',
      showUsage: false,
    },
    profile: {
      firstName: '',
      lastName: '',
      jobTitle: '',
      timezone: 'UTC',
    },
    organization: {
      name: '',
      domain: '',
      industry: '',
      timezone: 'UTC',
      plan: '',
      seats: null,
      billingEmail: '',
    },
    projects: [],
    activeProjectId: null,
    activeTeamId: null,
    library: [],
  };
}
